export default "__VITE_ASSET__616ff170__"